import {Routes, Route} from 'react-router-dom';
import {ThemeProvider} from 'styled-components';
import myTheme, {GlobalStyle} from './config/theme';

import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Join from './pages/Join';
import Play from './pages/Play';
import Footer from './components/Footer';
import {Page} from './components/Layout';

import './locales/i18n';
import Dashboard from './pages/Dashboard';
import DashboardLogin from './pages/DashboardLogin';
import DashboardSingle from './pages/DashboardSingle';
import DashboardAll from './pages/DashboardAll';
import HideJwtToken from './components/dashboard/HideJwtToken';

function App() {
  return (
    <ThemeProvider theme={myTheme}>
      <GlobalStyle />
      <Page>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/" element={<Home />} />
          <Route path="join" element={<Join />}>
            <Route path=":token" element={<Join />} />
          </Route>
          <Route path="play" element={<Play />}>
            <Route path=":token" element={<Play />} />
          </Route>
          <Route path="area-riservata" element={<NotFound />} />
          <Route
            path="area-riservata/:customerId"
            element={<DashboardLogin />}
          />
          <Route
            path="area-riservata/:id/:jwtToken"
            element={<HideJwtToken />}
          />
          <Route path="area-riservata/dashboard" element={<Dashboard />} />
          <Route
            path="area-riservata/giocate-condivise"
            element={<DashboardAll />}
          />
          <Route
            path="area-riservata/progetto/:token"
            element={<DashboardSingle />}
          />
        </Routes>
        <Footer />
      </Page>
    </ThemeProvider>
  );
}

export default App;
